import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConcorso = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 30,
	viewBox: "0 0 24 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Marker Box",
		filter: "url(#filter0_d_2466_14993)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Monumenti",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "shape",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M11.573 11.1468V15.7975C9.65295 15.5841 8.15963 13.9628 8.15963 12.0001C8.15963 10.8481 8.67162 9.78146 9.52497 9.09877L11.573 11.1468Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M15.8396 12.0001C15.8396 13.9628 14.3463 15.6268 12.4263 15.7975V11.1468L14.4743 9.09877C15.3276 9.78146 15.8396 10.8481 15.8396 12.0001Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M16.3089 7.26412L15.1143 8.45875C16.0956 9.3121 16.6929 10.5921 16.6929 12.0001C16.6929 14.6027 14.6023 16.6934 11.9996 16.6934C9.39694 16.6934 7.30627 14.6027 7.30627 12.0001C7.30627 10.5921 7.94629 9.35477 8.88495 8.45875L7.69027 7.26412C6.41028 8.45875 5.59961 10.1228 5.59961 12.0001C5.59961 15.5414 8.45827 18.4001 11.9996 18.4001C15.5409 18.4001 18.3996 15.5414 18.3996 12.0001C18.3996 10.1228 17.589 8.45875 16.3089 7.26412Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M11.9996 9.86677C13.1778 9.86677 14.1329 8.91163 14.1329 7.73343C14.1329 6.55523 13.1778 5.6001 11.9996 5.6001C10.8214 5.6001 9.86625 6.55523 9.86625 7.73343C9.86625 8.91163 10.8214 9.86677 11.9996 9.86677Z",
						fill: "white"
					})
				]
			})
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_2466_14993",
		x: -2,
		y: -2,
		width: 30,
		height: 36,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 1,
				dy: 1
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0.46 0 0 0 0 1 0 0 0 0.41 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_2466_14993"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_2466_14993",
				result: "shape"
			})
		]
	}) })]
});
export default SvgConcorso;
